import { render } from "./WallSpl.vue?vue&type=template&id=c3d8b6f8"
import script from "./WallSpl.vue?vue&type=script&lang=js"
export * from "./WallSpl.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__